import axios from 'axios';

import { authHeader } from '../_helpers';
import { urlAPI } from './index';

// ruta API de la entidad
let API = 'api/registro/';

// Exporta metodos
export const registroService = {
    getAll,
    getAllSelect,
    getById,
    putObject,
    postObject,
    deleteObject
};

// Lee todos los elementos
function getAll() {
    return axios.get(urlAPI + API, authHeader()).then(registro => {
        return registro.data;
    });
}

// Lee todos los elementos
function getAllSelect() {
    return axios.get(urlAPI + API + 'Select', authHeader()).then(registro => {
        return registro.data;
    });
}

// Lee un solo elemento de la entidad
function getById(id) {
    return axios.get(urlAPI + API + id, authHeader()).then(registro => {
        return registro.data;
    });
}

// Post de la entidad
function postObject(obj) {
    // Copiar todas las propiedades menos id
    var modelo = {
        nombre: obj.nombre,
        direccion: obj.direccion,
        localidadId: obj.localidad.id,
        provinciaId: obj.provincia.id,
        telefono: obj.telefono,
        mail: obj.mail,
        tipopersonaId: obj.tipopersona.id,
        observacion: obj.observacion,
        borrado: obj.borrado
    };
    return axios.post(urlAPI + API, modelo, authHeader()).then(registro => {
        // Completa nombre e id de la relacion en select
        registro.data.provincia = {
            id: obj.provincia.id,
            nombre: obj.provincia.nombre
        };
        // Completa nombre e id de la relacion en select
        registro.data.localidad = {
            id: obj.localidad.id,
            nombre: obj.localidad.nombre
        };
        // Completa nombre e id de la relacion en select
        registro.data.tipopersona = {
            id: obj.tipopersona.id,
            nombre: obj.tipopersona.nombre
        };
        return registro.data;
    });
}

// put de la entidad
function putObject(obj) {
    // Copiar todas las propiedades
    var modelo = {
        id: obj.id,
        nombre: obj.nombre,
        direccion: obj.direccion,
        localidadId: obj.localidad.id,
        provinciaId: obj.provincia.id,
        telefono: obj.telefono,
        mail: obj.mail,
        tipopersonaId: obj.tipopersona.id,
        observacion: obj.observacion,
        borrado: obj.borrado
    };
    return axios
        .put(urlAPI + API + modelo.id, modelo, authHeader())
        .then(registro => {
            // Completa nombre e id de la relacion en select
            registro.data.provincia = {
                id: obj.provincia.id,
                nombre: obj.provincia.nombre
            };
            // Completa nombre e id de la relacion en select
            registro.data.localidad = {
                id: obj.localidad.id,
                nombre: obj.localidad.nombre
            };
            return registro.data;
        });
}

// delete de la entidad
function deleteObject(obj) {
    return axios.delete(urlAPI + API + obj, authHeader()).then(registro => {
        return registro.data;
    });
}
